export default "__VITE_ASSET__DaxAlIhX__"